export default "__VITE_ASSET__5d4741cf__"